export enum GridType {
  AutoCol = 'autoCol',
}
